import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LeaveConfirmState {
  visible: boolean;
  title: string;
  message: string;
  actionKey: string | null;
}

const initialState: LeaveConfirmState = {
  visible: false,
  title: "",
  message: "",
  actionKey: null,
};

const leaveConfirmSlice = createSlice({
  name: "leaveConfirm",
  initialState,
  reducers: {
    showLeaveModal(
      state,
      action: PayloadAction<{
        title: string;
        message: string;
        actionKey: string;
      }>
    ) {
      state.visible = true;
      state.title = action.payload.title;
      state.message = action.payload.message;
      state.actionKey = action.payload.actionKey;
    },
    hideLeaveModal(state) {
      state.visible = false;
      state.title = "";
      state.message = "";
      state.actionKey = null;
    },
  },
});

export const { showLeaveModal, hideLeaveModal } = leaveConfirmSlice.actions;
export default leaveConfirmSlice.reducer;
